export default __webpack_public_path__ + "static/media/rocket_anim_36.6be8e767.png";